import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";
import { Reveal } from "./anim";

export default function Gallery() {
  const { t } = useLang();
  const g = t.gallery;
  const photos = [IMAGES.after1, IMAGES.after2, IMAGES.after3, IMAGES.after4];

  return (
    <section id="gallery" className="relative py-24 md:py-36 bg-cream" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{g.overline}</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.08] tracking-tight text-ink max-w-2xl">
              {g.title}
            </h2>
            <p className="font-light text-base leading-relaxed text-ink-soft max-w-sm">{g.note}</p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {photos.map((src, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
              className={`group relative overflow-hidden clip-frame ${i % 2 === 1 ? "lg:mt-10" : ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={src}
                alt={`${g.items[i]?.caption || "Massage à domicile"} — ${g.items[i]?.location || "Île-de-France"}`}
                className="w-full h-[440px] md:h-[520px] object-cover transition-transform duration-[900ms] group-hover:scale-105"
              />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
